// Generic dispatcher for the JobStatusResponse.Result envelope. The backend
// emits an object like { kind, ...payload } when a job has produced something
// the client should act on. New job kinds plug in here without touching every
// caller.
//
// Returns true if the result was consumed (i.e. an action fired).
export const consumeJobResult = (result) => {
	if (!result?.kind) return false;
	switch (result.kind) {
		case "download":
			return triggerBrowserDownload(result.url, result.fileName);
		case "redirect":
			if (result.url) {
				window.open(result.url, "_blank", "noopener,noreferrer");
				return true;
			}
			return false;
		default:
			return false;
	}
};

// Trigger a browser download via a transient anchor element. Using `download`
// hints the desired filename, though browsers ultimately honour the
// Content-Disposition header from the URL's HTTP response.
const triggerBrowserDownload = (url, fileName) => {
	if (!url) return false;
	const anchor = document.createElement("a");
	anchor.href = url;
	if (fileName) anchor.download = fileName;
	anchor.rel = "noopener";
	anchor.target = "_blank";
	document.body.appendChild(anchor);
	anchor.click();
	document.body.removeChild(anchor);
	return true;
};
